export const funcNavigate = (props, context) => {
    if (context.state.sNavigate !== null) {
        props(context.state.sNavigate)
        context.fResetNavigate()
    }
}